(function(){
  'use strict';

  function syncNeu(){
    document.querySelectorAll('.wohnica-new-wrap .wohnica-product-card').forEach(function(card){
      var select=card.querySelector('.wohnica-select');
      if(!select||select.dataset.wohnicaBound==='1')return;
      select.dataset.wohnicaBound='1';
      function update(){
        var option=select.options[select.selectedIndex];
        if(!option)return;
        var url=option.dataset.url||'#';
        var image=option.dataset.image||'';
        var title=option.dataset.title||option.textContent||'';
        var price=option.dataset.price||'';
        card.querySelectorAll('.wohnica-product-link').forEach(function(link){link.href=url});
        var pic=card.querySelector('.wohnica-product-image');
        if(pic&&image){pic.src=image;pic.alt=title}
        var titleNode=card.querySelector('.wohnica-selected-title');
        if(titleNode)titleNode.textContent=title;
        var priceNode=card.querySelector('.wohnica-price');
        if(priceNode&&price)priceNode.textContent=price;
      }
      select.addEventListener('change',update);
      update();
    });
  }

  function addFavoritenTrust(){
    var wrap=document.querySelector('.wohnica-favoriten-sync .wohnica-wrap');
    var hero=wrap&&wrap.querySelector('.wohnica-hero');
    if(!wrap||!hero||wrap.querySelector('.wohnica-trustbar'))return;
    var bar=document.createElement('div');
    bar.className='wohnica-trustbar';
    bar.setAttribute('aria-label','Vorteile bei Wohnica');
    bar.innerHTML='<div class="wohnica-trust-main"><strong>Kostenloser Versand</strong><span class="wohnica-delivery">3–7 Tage</span></div><span>✓ Sendungsverfolgung</span><span>✓ Sicher bezahlen</span><span>✓ 14 Tage Widerrufsrecht</span><span>✓ Direkter Wohnica Kontakt</span>';
    hero.insertAdjacentElement('afterend',bar);
  }

  function addCartPromise(){
    if(!window.matchMedia('(max-width:749px)').matches)return;
    document.querySelectorAll('.cart-drawer__summary').forEach(function(summary){
      if(summary.querySelector('.wohnica-cart-promise'))return;
      var ctas=summary.querySelector('.cart__ctas');
      if(!ctas)return;
      var box=document.createElement('div');
      box.className='wohnica-cart-promise';
      box.setAttribute('aria-label','Versand und Vorteile bei Wohnica');
      box.innerHTML='<div class="wohnica-cart-promise__main"><span class="wohnica-cart-promise__kicker">KOSTENLOSER VERSAND</span><strong>Versand mit Sendungsverfolgung</strong><span>Deine Lieferung kommt in der Regel in <b>3–7 Tagen</b>. Nach dem Versand erhältst du eine Sendungsnummer.</span><span class="wohnica-cart-promise__badge">Lieferzeit 3–7 Tage</span></div><div class="wohnica-cart-promise__grid"><span>✓ Sicher bezahlen</span><span>✓ 14 Tage Widerrufsrecht</span><span>✓ Direkter Wohnica Kontakt</span></div>';
      ctas.insertAdjacentElement('beforebegin',box);
    });
  }

  var scheduled=false;
  function run(){
    scheduled=false;
    syncNeu();
    addFavoritenTrust();
    addCartPromise();
  }
  function schedule(){
    if(scheduled)return;
    scheduled=true;
    window.requestAnimationFrame(run);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();

  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
  window.addEventListener('resize',schedule,{passive:true});
})();
